import React from "react";
import { Panel } from "components/bootstrap";
import HelpPanel from "components/event-definitions/common/HelpPanel";
import commonStyles from "./commonStyles.css";
class CorrelationPreview extends React.Component {
  constructor() {
    super(...arguments);
    this.renderRule = (rule) => {
      const { eventDefinitions } = this.props;
      const eventDefinition = eventDefinitions.find((d) => d.id === rule.event_creator_equals) || {};
      const title = rule.event_creator_equals ? eventDefinition.title : "No Event assigned yet";
      return /* @__PURE__ */ React.createElement("li", { key: rule.id }, title || "Event Definition not available");
    };
  }
  render() {
    const { rules } = this.props;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(HelpPanel, { collapsible: true, title: "How many Events will Event Correlation create?" }, /* @__PURE__ */ React.createElement("p", null, "Event Correlation will generate one Event when the series of Events occurs.")), /* @__PURE__ */ React.createElement(Panel, { className: commonStyles.preview, header: /* @__PURE__ */ React.createElement("h3", null, "Correlation Preview") }, /* @__PURE__ */ React.createElement("p", null, "Preview of execution order of the Event Correlation Rule."), rules.length === 0 ? /* @__PURE__ */ React.createElement("p", null, "No Event Correlation Rules configured yet.") : /* @__PURE__ */ React.createElement("ol", { className: commonStyles.previewList }, rules.map(this.renderRule))));
  }
}
export default CorrelationPreview;
